import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/links";
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  sublabel,
  id,
  className = ""
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`mx-auto flex w-full max-w-xl flex-col items-center justify-center rounded-2xl bg-cta px-5 py-4 text-center text-ink shadow-[0_6px_0_0_#15803D,0_14px_30px_-8px_rgba(34,197,94,0.55)] transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-1 active:shadow-[0_2px_0_0_#15803D] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/60 sm:py-5 ${className}`} data-id="element-28" data-mp="2fz20cka02sug">
      <span className="flex items-center gap-2 text-[17px] font-black uppercase leading-snug tracking-tight sm:text-xl" data-id="element-29" data-mp="3cpu7utivbckm">
        <span className="text-balance" data-id="element-30" data-mp="38osg0xra62so">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-31" data-mp="38m5z47ii2axs" />
      </span>
      {sublabel && <span className="mt-1 text-[13px] font-semibold text-ink/75" data-id="element-32" data-mp="19b9ae8poqws7">{sublabel}</span>}
    </a>;
}